export class TTemporaryGlobals
{
    TmpNumber = -1
}
export var TemporaryGlobals = new TTemporaryGlobals();